'use strict';

// modules which need to be inited
var lazyImage = require('lazy-image');
var customAnalytics = require('custom-analytics');
var domCache = require('dom-cache');

// app specific js files which need to be inited
var containerLink = require('container-link');
var locationMatcher = require('location-matcher');
var banner = require('./banner');
var productNav = require('./product-nav');
var vimeoApi = require('./vimeo-api');
var signUpBtn = require('./sign-up-btn');
var footer = require('./footer');
var pricing = require('./pricing');

// global modules, use package.json aliases
require('jquery-migrate');
require('velocity');
require('vimeo-analytics');

// app specific modules, use file names
require('./checkout');
require('./featureboxes');
require('./form');
require('./lightbox');
require('./menu');
require('./video');
require('./footer');

containerLink.init();

locationMatcher.init({
	useOrigin: true
});

banner.init();
productNav.init();
vimeoApi.init();
signUpBtn.init();
pricing.init();
footer.init();

domCache.document
	.find('.os-mac,.os-windows')
	.find('[data-container-link^="tel:"]')
	.attr('data-container-link', '/contact');

module.exports = {
	// Expose new browserify modules to legacy js.
	customAnalytics: customAnalytics,
	lazyImage: lazyImage

};
